import {
  operations as rootCauseOperations,
  constants as rootCauseConstants,
} from '@saucelabs/sl-module-root-cause';
import { recordTrack } from '@saucelabs/sl-util-segmentio';

import actions from './actions';
import * as constants from './../failure-analysis/constants';
import * as selectors from './selectors';

import { operations } from './index';

export const generalOperations = rootCauseOperations.createRootCauseOperations(actions);

export const getRootCauses = () => (dispatch, getState) => {
  const testHash = selectors.initFilterSelector(getState())?.id;
  return dispatch(generalOperations.getRootDetail(
    selectors.queryParamSelector(getState(), testHash ? { test_hash: testHash } : {}),
  ));
};

export const getRootCauseAnnotations = ({ patternId } = {}) => (dispatch, getState) => {
  const rootCauseItem = selectors.rootCauseDataSelector(getState(), { patternId });
  if (!patternId || !rootCauseItem || !rootCauseItem.get('annotations')) {
    return Promise.resolve();
  }
  const testHash = selectors.initFilterSelector(getState())?.id;
  const rootCauseParams = selectors.queryParamSelector(
    getState(),
    testHash ? { test_hash: testHash } : {},
  );
  return dispatch(generalOperations.getAnnotations(
    { patternId, ...rootCauseParams }, patternId, rootCauseItem,
  ));
};

export const selectTestAndRedirectToRootCauses = (payload) => (dispatch, getState) => {
  const queryParams = selectors.selectTestParamsSelector(getState(), payload);
  return Promise.all([
    dispatch(actions.pushPath(constants.FAILURE_ANALYSIS_PAGE_ROOT_CAUSES_URL, queryParams)),
    dispatch(actions.handleSelectTest(payload.test)),
    dispatch(recordTrack(rootCauseConstants.MIXPANEL_EVENTS.TEST_SELECTED)),
  ]);
};

export const resetTestAndGetRootCauses = (payload, meta) => (dispatch, getState) => {
  const queryParams = selectors.selectTestParamsSelector(getState(), null);
  return Promise.all([
    dispatch(actions.pushPath(constants.FAILURE_ANALYSIS_PAGE_ROOT_CAUSES_URL, queryParams)),
    dispatch(actions.handleResetTest(payload, meta)),
    dispatch(recordTrack(rootCauseConstants.MIXPANEL_EVENTS.TEST_RESET)),
  ]).then(() => dispatch(operations.getRootCauses()));
};

export const initRootCause = () => (dispatch, getState) => {
  const selectedTest = selectors.initFilterSelector(getState());

  if (!selectedTest?.id) {
    return Promise.resolve();
  }
  return dispatch(actions.handleSelectTest(selectedTest));
};

export const updateRootCause = (params) => (dispatch) => (
  dispatch(actions.updateRootCause(params, params))
);

export const getRootCauseTests = ({
  patternId, includeNextToken = false,
} = {}) => (dispatch, getState) => {
  const rootCauseItem = selectors.rootCauseDataSelector(getState(), { patternId });
  if (!patternId || !rootCauseItem) {
    return Promise.resolve();
  }

  const testHash = selectors.initFilterSelector(getState())?.id;
  const params = selectors.queryParamSelector(getState(), testHash ? { test_hash: testHash } : {});
  return dispatch(generalOperations.getTests({
    params: { rootCauseId: patternId, ...params },
    patternId,
    rootCauseItem,
    includeNextToken,
  }));
};

export const getRootCauseAdditionalData = (params) => (dispatch, getState) => {
  const { isDataExists } = selectors.rootCauseAdditionalDataSelector(getState(), params);

  return isDataExists ? Promise.resolve() : (
    Promise.all([
      dispatch(operations.getRootCauseAnnotations(params)),
      dispatch(operations.getRootCauseTests(params)),
    ])
  );
};
